import { Mark } from "tiptap";
import { toggleMark } from "tiptap-commands";

export default class CustomButton extends Mark {
    get name() {
        return "custombutton";
    }

    get defaultOptions() {
        return {
            levels: ["body-green", "body-red", "body-blue"]
        };
    }

    get schema() {
        // console.log("get schema");
        return {
            attrs: {
                level: {
                    default: "body-green"
                }
            },
            parseDOM: [
                {
                    tag: "span.custom-style",
                    getAttrs(dom) {


                        return { level: dom.classList[1] };
                    }
                }
            ],
            toDOM: mark => {
                // console.log("marks");
                // alert(mark);
                // console.log(mark);

                return ["span", { class: `custom-style ${mark.attrs.level}` }, 0];
            }
        };
    }

    commands({ type }) {


        return attrs => {
            // console.log(type);
            return toggleMark(type, attrs);
        }
    }
}
